import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

export const SecureZone = ({ component: Component, ...rest }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) return null;

  return isAuthenticated ? <Component {...rest} /> : <Navigate to="/login" />;
};
